import { useCallback, useState } from "react";
import moment from "moment";
import {
  ListarFiltroEmailQuery,
  FiltroStatusEmail,
} from "core/features/relatorios/typings";
import { TipoDestinoEnum } from 'core/features/documentos/enums';

export const defaultValuesFiltroEmail: ListarFiltroEmailQuery = {
  page: 1,
  search: "",
  dataFim: moment().format("YYYY-MM-DD"),
  dataInicio: moment().startOf("month").format("YYYY-MM-DD"),
  assuntos: [],
  status: FiltroStatusEmail.Todos,
  destinoId: '',
  tipoDestinoId: TipoDestinoEnum.TodasUnidades,
};

function useFiltroEmail() {
  const [filtro, setFiltro] = useState<ListarFiltroEmailQuery>(defaultValuesFiltroEmail);

  const onChangeFiltro = useCallback(
    (_filtro: Partial<ListarFiltroEmailQuery>) => {
      setFiltro((state) => ({ ...state, ..._filtro }));
    },
    []
  );


  const onResetFiltro = useCallback(() => {
    setFiltro(defaultValuesFiltroEmail);
  }, []);
  return {
    filtro,
    setFiltro,
    onChangeFiltro,
    onResetFiltro,
  };
}

export default useFiltroEmail;
